import { parseCTACardFromCMS } from '@/lib/contentstack-sdk/utils/parseHelpers';
import { MlCtaCard } from './ml-cta-card';
import { TMlCtaCardCS } from './ml-cta-card.types';

// types

export const MlCtaCardCS = ({
  block,
  className,
  element,
  interactLocation,
}: TMlCtaCardCS) => {
  const parsedData = parseCTACardFromCMS(block);

  return (
    <MlCtaCard
      {...parsedData}
      element={element}
      className={className}
      interactLocation={interactLocation}
    />
  );
};
